<template>
	<div v-closable="close" :class="['sk-profile-user-account', { 'sk-profile-user-account--open': isOpen }]">
		<div class="sk-profile-user-account-wrapper" @click="onToggle_ClickHandler">
			<avatar class="sk-profile-user-account__picture " :src="currentUser.picture" :name="currentUser.fullname" />
			<div class="sk-profile-user-account__info">
				<div class="sk-profile-user-account__info--name">in {{ currentUser.fullname }}</div>
				<div class="sk-profile-user-account__info--type">as {{ currentUser.type }}</div>
			</div>
			<div class="sk-profile-user-account__more-options"></div>
		</div>
		<div class="sk-profile-user-account-more-options">
			<div>
				<div>
					<slot></slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Avatar from '@/modules/ui/Avatar'
import Closable from '@/directives/Closable'
export default {
	name: 'profile-user-account',
	components: {
		Avatar
	},
	directives: {
		Closable
	},
	data() {
		return {
			isOpen: false
		}
	},
	methods: {
		onToggle_ClickHandler() {
			this.isOpen = !this.isOpen
		},
		close() {
			this.isOpen = false
		}
	},
	computed: {
		...mapGetters({
			currentUser: 'CURRENT_USER'
		})
	},
	created() {
		this.$on('close', this.close)
	},
	destroyed() {
		this.$off('close', this.close)
	}
}
</script>

<style scoped>
.sk-profile-user-account {
	position: relative;
	width: 100%;
	border-bottom: 1px solid rgba(0,0,0,0.1);
}
.sk-profile-user-account-wrapper {
	display: flex;
	align-items: center;
	width: 100%;
	padding: 20px;
	position: relative;
	z-index: 11;
	cursor: pointer;
}
.sk-profile-user-account__picture {
	margin: 0 10px 0 0;
}
.sk-profile-user-account__info {
	flex: 1;
}
.sk-profile-user-account__info--name,
.sk-profile-user-account__info--type {
	color: #fff;

}
.sk-profile-user-account__info--name {
	font-weight: 900;
	font-size: 13px;
	margin: 0 0 2px 0;
}
.sk-profile-user-account__info--type {
	text-transform: uppercase;
	font-size: 9px;
}
.sk-profile-user-account__more-options {
	height: 15px;
	width: 15px;
	flex: 0 0 15px;
	background-color: var(--main-color-bg-t-1);
	background-image: url(/static/svg/buttons/down-arrow.svg);
	background-size: 7px 7px;
	background-repeat: no-repeat;
	background-position: center;
	border-radius: 3px;
	margin: 0 0 0 10px;
	transform: rotate(0deg);
	transition: transform 1s;
	cursor: pointer;
}
.sk-profile-user-account__more-options:hover {
	background-color: var(--main-color-bg-t-2);
}
.sk-profile-user-account-more-options {
	padding: 90px 0 0 0;
	position: absolute;
	z-index: 10;
	top: 0;
	left: 0;
	width: 100%;
	background-color: var(--main-color-soft);
	display: flex;
	flex-direction: column;
	clip-path: inset(0 0 100% 0);
	transition: clip-path 0.3s;
}
.sk-profile-user-account-more-options > div {
	border-top: 1px solid var(--main-color-line-1);
}
.sk-profile-user-account-more-options > div > div {
	transform: translate(0, 100%);
	opacity: 0;
	transition: all 1s;
	padding: 30px 30px 40px 30px;
}
.sk-profile-user-account.sk-profile-user-account--open .sk-profile-user-account-more-options > div > div {
	transform: translate(0, 0);
	opacity: 1;
}
.sk-profile-user-account.sk-profile-user-account--open .sk-profile-user-account-more-options {
	clip-path: inset(0 0 0 0);
}
.sk-profile-user-account.sk-profile-user-account--open .sk-profile-user-account__info--name,
.sk-profile-user-account.sk-profile-user-account--open .sk-profile-user-account__info--type {
	color: var(--main-font-color-invert-2);
}
.sk-profile-user-account.sk-profile-user-account--open .sk-profile-user-account__more-options {
	transform: rotate(180deg);
	background-color: var(--main-color-bg-t-3);
}
</style>



// WEBPACK FOOTER //
// src/components/navigation/account/ProfileUserAccount.vue